import { render, staticRenderFns } from "./Suggestion.vue?vue&type=template&id=166988e4&scoped=true&lang=pug&"
import script from "./Suggestion.vue?vue&type=script&lang=js&"
export * from "./Suggestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166988e4",
  null
  
)

export default component.exports